const API_URL = process.env.REACT_APP_API_URL || '/api';

export interface HiredEquipmentRowAttachmentDto {
  filename: string;
  contentType: string;
  size: number;
  url: string;
  key: string;
}

export async function uploadHiredEquipmentRowAttachment(file: File): Promise<HiredEquipmentRowAttachmentDto> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${API_URL}/hired-equipment/attachments`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    let message = 'Failed to upload attachment';
    try {
      const body = (await response.json()) as { error?: string; details?: string };
      message = body?.error || body?.details || message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }
  return response.json() as Promise<HiredEquipmentRowAttachmentDto>;
}

export interface HiredEquipmentSubmissionPdf {
  id: number;
  formId: string;
  identifier: string;
  filename: string;
  contentType: string;
  url: string;
  path: string;
  taskIndex: number | null;
  imageMetadata: null;
  createdAt: string;
  updatedAt: string;
}

async function readError(response: Response, fallback: string): Promise<string> {
  try {
    const body = (await response.json()) as { error?: string; details?: string };
    return body?.error || body?.details || fallback;
  } catch {
    return fallback;
  }
}

/** Add a PDF ticket or invoice to one line of a submitted form, including after approval. */
export async function addHiredEquipmentSubmissionPdf(
  formId: string,
  lineIndex: number,
  file: File,
): Promise<HiredEquipmentSubmissionPdf> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('lineIndex', String(lineIndex));
  const response = await fetch(`${API_URL}/hired-equipment/submissions/${formId}/attachments`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    throw new Error(await readError(response, 'Failed to add PDF'));
  }
  return response.json() as Promise<HiredEquipmentSubmissionPdf>;
}

/** Remove a PDF ticket or invoice from a submitted form, including after approval. */
export async function removeHiredEquipmentSubmissionPdf(
  formId: string,
  attachmentId: number,
): Promise<void> {
  const response = await fetch(
    `${API_URL}/hired-equipment/submissions/${formId}/attachments/${attachmentId}`,
    { method: 'DELETE', credentials: 'include' },
  );
  if (!response.ok) {
    throw new Error(await readError(response, 'Failed to remove PDF'));
  }
}
